import { normalizeFields } from "@/forms/helpers";

export const model = normalizeFields({
  emailOrPwz: {
    type: "text",
    label: "login.form.email_or_pwz",
    value: "",
    required: true,
  },
  password: {
    type: "password",
    label: "login.form.password",
    value: "",
    required: true,
  },
});
